export const options = {
    mouseWheelIsEnable: true,
    mouseWheelXSpeed: 1,
    mouseWheelYSpeed: 1,
    mouseWheelInertiaScale: 1.5,
    inertiaScrollEnabled: false,
    mouseMoveIsEnable: true,
    mouseMoveXSpeed: 1,
    mouseMoveYSpeed: 1,
    mouseMoveInertiaXDeceleration: Infinity,
    mouseMoveInertiaYDeceleration: Infinity,
    mouseMoveInertiaXMaxSpeed: Infinity,
    mouseMoveInertiaYMaxSpeed: Infinity,
    touchIsEnable: true,
    touchXSpeed: 1,
    touchYSpeed: 1,
    touchInertiaXDeceleration: Infinity,
    touchInertiaYDeceleration: Infinity,
    touchInertiaXMaxSpeed: Infinity,
    touchInertiaYMaxSpeed: Infinity,
    arrowScrollX: 40,
    arrowScrollY: 40,
    minScrollTop: 0,
    minScrollLeft: 0,
    maxScrollTop: Infinity,
    maxScrollLeft: 0,
};
//# sourceMappingURL=options.js.map